import { env } from '../../config';
import React, { useState, useEffect } from 'react';
import {
	NavLink,
} from 'react-router-dom';
import Select from 'react-select';

import clip from '../../images/icons/analytics/clip.svg';
import deleteReport from '../../images/icons/analytics/trash.svg';
import disabledClip from '../../images/icons/analytics/clip-disabled.svg';
import disabledDeleteReport from '../../images/icons/analytics/trash-disabled.svg';
import disabledDownloadReport from '../../images/icons/analytics/download-disabled.svg';
import disabledLightbulb from '../../images/icons/analytics/lightbulb-disabled.svg'
import disabledPopout from '../../images/icons/analytics/popout-disabled.svg';
import disabledRecreate from '../../images/icons/analytics/recreate-disabled.svg'
import downloadReport from '../../images/icons/analytics/download.svg';
import filter from '../../images/icons/analytics/filter.svg';
import lightbulb from '../../images/icons/analytics/lightbulb.svg'
import lightClip from '../../images/icons/analytics/clip-light.svg';
import openReport from '../../images/icons/analytics/open-report.svg';
import popout from '../../images/icons/analytics/popout.svg';
import recreate from '../../images/icons/analytics/recreate.svg'
import refresh from '../../images/icons/analytics/refresh.svg';
import sort from '../../images/icons/analytics/sort.svg';

import { getReports, removeReport, truncateReportName, downloadCsv, getInsightsPlaylists, getCsvUrl } from './controller';
import { constants, formatDate } from '../../utils'

const ReportAnalyticsPage = ({
	customer,
	userData,
	permissions
}) => {

	const [openModal, setOpenModal] = useState(false);
	const [openInsightsModal, setOpenInsightsModal] = useState(false);
	const [highlightedReport, setHighlightedReport] = useState({});
	const [selectedReport, setSelectedReport] = useState({});
	const [insightsPlaylists, setInsightsPlaylists] = useState([]);
	const [selectedAddressLabel, setSelectedAddressLabel] = useState('');
	const [selectedUrl, setSelectedUrl] = useState({value: '1-4Zo1FhJcrwzlsbsf4lVOsR' ,label: 'Transportation and Travel Time'});
	const [dropdownOptions, setDropdownOptions] = useState([]);
	const [reportData, setReportData] = useState([])
	const [showRemoveModal, setShowRemoveModal] = useState(false);
	const [showRecreateModal, setShowRecreateModal] = useState(false);

	const urlOptions = [
		{value: '1-4Zo1FhJcrwzlsbsf4lVOsR' ,label: 'Transportation and Travel Time'},
		{value: '1-3cUT5LPdQdf4nt4T8cKb1e' ,label: 'Survey and AI analysis'},
		{value: '1-7FSVHerqqiMFkdwSqwQDFF' ,label: 'Program Manager'},
		{value: '1-1nWZVKsDhRCNcAmuq4Xf93' ,label: 'Geographic Distribution'},
		{value: '1-6gspMOHVYeXnZGnXIJZn1y' ,label: 'Relocation: Driving analysis'},
		{value: '1-1QoqmwXIYRIFvuFyFj0mtf' ,label: 'Relocation: Transit analysis'},
		{value: '1-5OGsPYkal3PgB4OtZZ045J' ,label: 'Relocation: AI analysis'},
	]

	const getForesightAccessLevel = () => {
		const foresight = permissions.foresight;

		if (!foresight) return null;

		let foundViewer = false;

		for (const rolesArray of Object.values(foresight)) {
			if (rolesArray.includes('editor')) {
				return 'editor'; // immediately return if editor is found
			}
			if (rolesArray.includes('viewer')) {
				foundViewer = true;
			}
		}
	  
		return foundViewer ? 'viewer' : null;
	}

	// General access level of current user on Foresight page.
	// If no explicit permission, then access level is as good as viewer permission.
	const accessLevel = getForesightAccessLevel();
	const isDisabled = !accessLevel || accessLevel === 'viewer';

	useEffect(() => {
		getReports(customer.id, setReportData);
		getInsightsPlaylists(customer.id, setInsightsPlaylists);
	}, [])

	const handleReportSelection = async (report) => {
		if (report.status === 'ready' && Object.keys(highlightedReport).length !== 0) {
			const userInputs = report?.userInputs;
			await getCsvUrl(userInputs?.fileName, userInputs?.reportName)
			.then(url => {
				setSelectedReport({
					...report,
					downloadUrl: url
				});
				const labelOptions = report.addressLabels.map(label => {
					return {
						value: label,
						label
					}
				})
				setDropdownOptions(labelOptions);
				setSelectedAddressLabel(labelOptions[0] || {value: '', label: 'Select...'});
				setOpenModal(false);
			})
		}
	}

	//Different modals we have for this page
	const renderModal = () => {
		if (openModal) return <Modal reportData={reportData} highlightedReport={highlightedReport} setHighlightedReport={setHighlightedReport} setOpenModal={setOpenModal} handleReportSelection={handleReportSelection} selectedReport={selectedReport} customerId={customer.id} setReportData={setReportData}/>;
		if (openInsightsModal) return <InsightsModal insightsPlaylists={insightsPlaylists} setOpenInsightsModal={setOpenInsightsModal}/>;
		if (showRemoveModal) return <RemoveModal selectedReport={selectedReport} customerId={customer.id} setReportData={setReportData} setSelectedReport={setSelectedReport} setShowRemoveModal={setShowRemoveModal} setDropdownOptions={setDropdownOptions} />;
		if (showRecreateModal && selectedReport?.userInputs !== null) return <RecreateModal setShowRecreateModal={setShowRecreateModal} userInputs={selectedReport?.userInputs} downloadUrl={selectedReport?.downloadUrl} />;
		return null;
	};

	return ( 
		<div className="ReportAnalyticsPage">
			{renderModal()}
			<div className="report-selector">
				<button className="open-report pure-u-1-5" onClick={() => setOpenModal(true)}>
					<img className="open-icon" src={openReport}/>
				</button>
				<div className="report-name pure-u-1-7">
					{
						selectedReport.name
						? <div className="name-container">
							<p className="name">{truncateReportName(selectedReport.name)}</p>
							<p>Generated on {formatDate(selectedReport.generatedDate)} by {selectedReport.createdBy}</p>
						</div>							
						: <div className="name-container">
							<p className="name">No report selected.</p>
							<p>Open a report to view analytics</p>
						</div>	
					}
				</div>
				<div className="report-dropdown pure-u-1-5">
					<Select  
						onChange={(option) => setSelectedAddressLabel(option)}
						options={dropdownOptions}
						value={selectedAddressLabel}
						className={"dropdown"}
						isDisabled={dropdownOptions.length === 0}
						styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
					/>
				</div>
				<div className="report-dropdown pure-u-1-5">
					<Select  
						onChange={(option) => setSelectedUrl(option)}
						options={urlOptions}
						value={selectedUrl}
						className={"dropdown"}
						isDisabled={!selectedReport?.id}
						styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
					/>
				</div>
				<div className="report-actions pure-u-1-4">
					{/* <div className={`icon-container ${(isDisabled || !selectedReport.name) ? "disabled" : "insight-icon"}`} title="Send Actionfigure Insight link" onClick={(isDisabled || !selectedReport.name) ? null : () => setOpenInsightsModal(true)}>
						<img className="icon" src={(isDisabled || !selectedReport.name) ? disabledLightbulb : lightbulb} />
					</div> */}
					<div className={`icon-container ${(isDisabled || !selectedReport.name) ? "disabled" : ""}`} title="Copy link to report" onClick={(isDisabled || !selectedReport.id) ? null : () => navigator.clipboard.writeText(`${env.LOADER_URL}/${selectedReport.shortCode}`)}>
						<img className="icon" src={(isDisabled || !selectedReport.name) ? disabledClip : clip} />
					</div>
					<div className="vertical-line"></div> 
					<div className={`icon-container ${(isDisabled || !selectedReport.name) ? "disabled" : ""}`} title="Re-run report " onClick={(isDisabled || !selectedReport.id) ? null : () => setShowRecreateModal(true)}>
						<img className="icon" src={(isDisabled || !selectedReport.name) ? disabledRecreate : recreate} />
					</div>
					{/* Open go.actionfigure.ai link if there is a short code*/}
					<div className={`icon-container ${(isDisabled || !selectedReport.name) ? "disabled" : ""}`} title="Open in new window" onClick={(isDisabled || !selectedReport.id) ? null : () => selectedReport.shortCode ? window.open(`${env.LOADER_URL}/${selectedReport.shortCode}`, '_blank').focus() : null}>
						<img className="icon" src={(isDisabled || !selectedReport.name) ? disabledPopout : popout} />
					</div>
					<div className={`icon-container ${(isDisabled || !selectedReport.name) ? "disabled" : ""}`} title="Download data" onClick={(isDisabled || !selectedReport.id) ? null : () => downloadCsv(selectedReport.id, selectedReport.name)}>
						<img className="icon" src={(isDisabled || !selectedReport.name) ? disabledDownloadReport : downloadReport} />
					</div>
					<div className={`icon-container ${(isDisabled || !selectedReport.name) ? "disabled" : ""}`} title="Delete report" onClick={(isDisabled || !selectedReport.id) ? null : () => setShowRemoveModal(true)}>
						<img className="icon" src={(isDisabled || !selectedReport.name)  ? disabledDeleteReport : deleteReport} />
					</div>
				</div>
			</div>
			<div className="iframe-container">
				<iframe className="sigma-iframe" zoom='50' width='100%' height='100%' src={`https://app.sigmacomputing.com/embed/${selectedUrl.value}?ReportID=${selectedReport?.id}&Office-for-Analysis=${selectedAddressLabel?.value}&:show_footer=false`}/>
			</div>
		</div>
	)
}

const InsightsModal = ({insightsPlaylists, setOpenInsightsModal}) => {

	const [userInputs, setUserInputs] = useState({
		shortCode: '',
		personId: '',
		link: ''
	})

	const handleInputChange = (val, param) => {
		const tempInputs = {...userInputs};
		tempInputs[param] = val;
		setUserInputs(tempInputs);
	}

    return (
		<div className="modal-wrapper">
			<div className="InsightsModal modal">
				<div className="input-container">
					<p className="pure-u-1-8">Instance: </p>
					<Select
						onChange={(e) => handleInputChange(e.value, 'shortCode')}
						options={insightsPlaylists.map(pl => {
							return { value: pl.shortCode, label: pl.shortCode }
						})}
						value={{ value: userInputs.shortCode, label: userInputs.shortCode }}
						className={"dropdown text-input pure-u-1-3"}
						styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
					/>
				</div>
				<div className="input-container">
					<p className="pure-u-1-8">Person ID: </p>
					<input className={`text-input pure-u-1-3`} onChange={(e) => handleInputChange(e.target.value, 'personId')} value={userInputs.personId}></input>
				</div>
				<div className="input-container">
					<p className="pure-u-1-8">Insight link: </p>
					<input className={`text-input pure-u-1-3`} onChange={(e) => handleInputChange(e.target.value, 'link')} value={`${env.LOADER_URL}/${userInputs.shortCode}?personId=${userInputs.personId}`} disabled></input>
					<div className="icon-container" title="Copy Link" onClick={() => navigator.clipboard.writeText(`${env.LOADER_URL}/${userInputs.shortCode}?personId=${userInputs.personId}`)}>
						<img className="icon" src={lightClip} />
					</div>
				</div>
				<div className="bottom-container">
					<div className="buttons-container">
						<button className="modal-button" onClick={() => setOpenInsightsModal(false)}>Done</button>
					</div>
				</div>
			</div>
		</div>
    )
}

const Modal = ({reportData, highlightedReport, setHighlightedReport, setOpenModal, handleReportSelection, selectedReport, customerId, setReportData }) => {

	const [searchOwner, setSearchOwner] = useState(null);
	const [filteredReports, setFilteredReports] = useState([...reportData]);

	useEffect(() => {
		// Prevent scrolling when modal is open
		document.body.classList.add("no-scroll");
	
		return () => {
			// Allow scrolling when modal is closed
			document.body.classList.remove("no-scroll");
		};
	}, []);

	const filterReports = (searchString) => {
		//Update search value
        setSearchOwner(searchString);
		setFilteredReports(searchString.length > 0 ? reportData.filter(report => {
			if (report.createdBy) {
				return report.createdBy.slice(0, searchString.length).toLowerCase() === searchString.toLowerCase();   
			}
			return false
		 }) : reportData); //If no search string, set to regular customers array
	}

	const reportRows = filteredReports.length === 0 || !filteredReports
	? <tr><td>No reports are avaialble</td></tr>
	: filteredReports.map((report, index) => {
		const formattedGenerationTime = formatDate(report.createdAt);

		return <tr 
			key={report.id} 
			className={`report-row ${report.id === highlightedReport.id ? "selected" : ""} ${report.status === 'processing' || report.status === 'preparing' ? "processing" : ""} ${report.id === selectedReport.id ? 'current-report' : ""}`} 
			onClick={() => report.status === 'ready' ? setHighlightedReport(report) : null}
		>
				<td>{report.name}</td>			
				<td>{formattedGenerationTime}</td>
				<td>{report.createdBy}</td>
				<td>{report.status.charAt(0).toUpperCase() + report.status.slice(1)}</td>
		</tr>
	})

    return (
		<div className="modal-wrapper">
			<div className="SelectReportModal modal">
				<div className="modal-header">
					<h2>Your Foresight reports</h2>
					<div className="header-buttons">
						<button className="header-button" title="Coming soon"><img src={sort} /></button>
						<button className="header-button" title="Coming soon"><img src={filter} /></button>
						<button onClick={() => getReports(customerId, setReportData)} className="header-button"><img src={refresh} /></button>
					</div>
				</div>
				<div className="table-container">
					<table className="reports-table">
						<tbody>
							<tr className="header-row">
								<th className="table-header">Name</th>
								<th className="table-header">Date</th>
								<th className="table-header">Owner</th>
								<th className="table-header">Status</th>
							</tr>
							{reportRows}
						</tbody>
					</table>
				</div>
				<div className="bottom-container">
					<div className="filter-container">
						<p>Search</p>
						<input 
							onChange={(e) => filterReports(e.target.value)}
							className={"owner-search"}
							value={searchOwner || ''}
						/>
					</div> 
					<div className="buttons-container">
						<button className="modal-button cancel" onClick={() => setOpenModal(false)}>Cancel</button>
						<button className={`modal-button ${Object.keys(highlightedReport).length === 0 ? 'disabled-button' : " "}`} onClick={() => handleReportSelection(highlightedReport)}>Open</button>
					</div>
				</div>
			</div>
        </div>
    )
}

const RemoveModal = ({ selectedReport, customerId, setReportData, setSelectedReport, setShowRemoveModal, setDropdownOptions }) => {
	
	const handleRemove = () => {
		removeReport(selectedReport.id, customerId, setReportData, setSelectedReport);
		setDropdownOptions([]);
		setShowRemoveModal(false);
	}

    return (
		<div className="modal-wrapper">
			<div className="RemoveModal modal">
				<h2>Are you sure you want to delete {selectedReport.name}?</h2>
				<div className="bottom-container">
					<div className="buttons-container">
						<button className="modal-button cancel" onClick={() => setShowRemoveModal(false)}>No</button>
						<button className={`modal-button`} onClick={handleRemove}>Yes</button>
					</div>						
				</div>
			</div>
		</div>
    )
}

const RecreateModal = ({ setShowRecreateModal, userInputs, downloadUrl }) => {

	const formatAddress = (label, address) => {
		if (!label || label === '') return;
		return `${label} - ${address.address}`
	}

    return (
		<div className="modal-wrapper">
			<div className="modal RecreateModal">
				<h2 style={{textAlign: 'left'}}>Recreate report</h2>
				<div className="scroll-section">
					<div className="input-container">
						<p className="pure-u-1-5">Direction of travel:</p>
						<p className="pure-u-1-2">{userInputs?.isFromOffice?.label}</p>
					</div>
					<div className="input-container">
						<p className="pure-u-1-5">Day of week:</p>
						<p className="pure-u-1-2">{constants.WEEKDAYS[userInputs?.selectedDay.value]}</p>
					</div>
					<div className="input-container">
						<p className="pure-u-1-5">Time of day:</p>
						<p className="pure-u-1-2">{userInputs?.travelTime?.value}</p>
					</div>
					<div className="input-container">
						<p className="pure-u-1-5">Current office address:</p>
						<p className="pure-u-1-2">{formatAddress(userInputs?.addressLabels[0], userInputs?.addresses[0])}</p>
					</div>
					<div className="input-container">
						<p className="pure-u-1-5">Prospective address 1:</p>
						<p className="pure-u-1-2">{formatAddress(userInputs?.addressLabels[1], userInputs?.addresses[1])}</p>
					</div>
					<div className="input-container">
						<p className="pure-u-1-5">Prospective address 2:</p>
						<p className="pure-u-1-2">{formatAddress(userInputs?.addressLabels[2], userInputs?.addresses[2])}</p>
					</div>
					<div className="input-container">
						<p className="pure-u-1-5">Prospective address 3:</p>
						<p className="pure-u-1-2">{formatAddress(userInputs?.addressLabels[3], userInputs?.addresses[3])}</p>
					</div>
					<div className="input-container">
						<p className="pure-u-1-5">Prospective address 4:</p>
						<p className="pure-u-1-2">{formatAddress(userInputs?.addressLabels[4], userInputs?.addresses[4])}</p>
					</div>
					<div className="input-container">
						<p className="pure-u-1-5">Prospective address 5:</p>
						<p className="pure-u-1-2">{userInputs?.addresses[5]}</p>
					</div>
					<div className="input-container">
						<p className="pure-u-1-5">Employee location list:</p>
						<p className="pure-u-1-2"><a href={downloadUrl} download={userInputs.reportName}>Download file</a></p>
					</div>
				</div>
				<div className="bottom-container">
					<div className="buttons-container">
						<button className="modal-button cancel" onClick={() => setShowRecreateModal(false)}>Cancel</button>
						<NavLink 
							to={{
								pathname: '/foresight',
								userInputs: userInputs
							}} 
							className={`modal-button`}
						>
							<p style={{marginTop: '0.6em'}}>Recreate report</p>
						</NavLink>
					</div>
				</div>
			</div>
        </div>
    )
}

export default ReportAnalyticsPage;
